<template>
    <div class="userlist-wrap">
       <el-table :data="userlist">
            <el-table-column label="昵称"  prop="nickName"></el-table-column>
            <el-table-column label="图像" prop="avatarUrl" >
                <template slot-scope="scope">
                    <div>
                        <el-image
                        style="height: 60px;"
                        :src="scope.row.avatarUrl"></el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="手机号" prop="mobile" ></el-table-column>
            <el-table-column label="注册来源"  prop="payment">
                <template slot-scope="scope">
                    <div>
                        <el-tag type="success" v-if="scope.row.reg_source == '1'">小程序</el-tag>
                        <el-tag type="success" v-else-if="scope.row.reg_source == '2'">公众号</el-tag>
                        <el-tag type="success" v-else-if="scope.row.reg_source == '3'">苹果app</el-tag>
                        <el-tag type="success" v-else-if="scope.row.reg_source == '4'">安卓app</el-tag>
                        <el-tag type="success" v-else-if="scope.row.reg_source == '5'">pc端</el-tag>
                        <el-tag type="success" v-else-if="scope.row.reg_source == '6'">h5(非微信h5环境)</el-tag>
                        <el-tag type="success" v-else-if="scope.row.reg_source == '7'">支付宝小程序</el-tag>
                        <el-tag type="warning" v-else>其他</el-tag>

                    </div>
                </template>
            </el-table-column>
            <el-table-column label="渠道码"  prop="payment"></el-table-column>
            <el-table-column label="支付宝名称" prop="nickName"></el-table-column>
            <el-table-column label="支付宝账号" prop="open_id"></el-table-column>
            <el-table-column label="创建时间" width="140px" prop="create_time"></el-table-column>
            <el-table-column label="状态" ></el-table-column>
       </el-table>
       <div class="pagination" slot="footer">
        <el-pagination 
            @size-change="handleSizeChange" 
            @current-change="handleCurrentChange" 
            background 
            :current-page="searchForm.curPage"
            :page-size="searchForm.pageSize" 
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="searchForm.total">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import ChannelApi from '@/api/channel.js';
export default {
    data(){
        return{
            searchForm:{
                curPage:1,
                pageSize:10,
                total:0
            },
            userlist:[]
        }
    },
    created(){
        this.getUserList()
    },
    methods:{
        handleCurrentChange(val){
            this.searchForm.curPage = val;
        },
        handleSizeChange(val){
            this.searchForm.pageSize = val;
        },
        getUserList(){
            ChannelApi.userlist({}, true).then(res=>{
                // console.log('userlist', res);
                const {data, total} = res.data.list
                this.userlist = data
                this.searchForm.total = total
            })
        },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/channel/user/userlist.vue